import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import {firebase} from '@/firebase'
import routes from './routes'

Vue.use(Router);


const router = new Router({
  mode: 'history', // require service support
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  linkActiveClass: 'active',
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const currentUser = firebase.auth().currentUser;
  if (requiresAuth && !currentUser) {
    next({
      path: `/login`,
      query: {redirect: to.fullPath}
    })
  } else {
    next()
  }
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js